<template>
  <div class="form-floating" style="width: 100%;font-family: inherit;">
    <label :for="field.id" :style="styleLabel(field,'')">{{ field.label }}</label>
    <div class="d-flex align-items-center position-relative" style="height: 100%; width: 100%;">
      <div class="ml-4 w-100" style="padding-top: 2px;">
        <div class="form-check form-switch caja d-flex align-items-center w-100 flex-wrap">
          <div v-for="option in field.radio" :key="option.value" class="form-check form-check-inline radio-option">
            <input 
              type="radio" 
              :class="['owl360-form-check-input', field.class, { 'is-invalid': errorMessages[field.id] }]"
              :id="field.id + '-' + option.value"
              :name="name"
              :value="option.value"
              v-model="localData"
              :disabled="field.readonly === true"
              @change="updateValue(option.value)"
            />
            <label :for="field.id + '-' + option.value" class="form-check-label" :style="styleLabel(field,'line-height: 1.5em;')">
              {{ option.label }}
            </label>
          </div>
          <div @click="togglePopup" @mouseenter="keepPopupOpen" @mouseleave="delayedClosePopup">
            <i class="fas fa-info-circle info-icon"></i>
          </div>
          <div v-if="showPopup" class="info-popup" 
               :style="{ top: popupPosition.top + 'px', left: popupPosition.left + 'px' }" 
               @mouseenter="keepPopupOpen"
               @mouseleave="delayedClosePopup">
            <div v-html="field.info"></div>
          </div>
          <div class="invalid-feedback" style="display: block;">
            {{ errorMessages[field.id] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true
    },
    formValues: {
      type: Object,
      required: true
    },
    errorMessages: {
      type: Object,
      required: true
    },
    name: {type: String}
  },
  data() {
    return {
      localData: this.normalizeValue(this.formValues[this.field.id]),
      showPopup: false,
      popupPosition: { top: 0, left: 0 },
      popupTimeout: null // Para manejar el retraso en el cierre
    };
  },
  watch: {
    formValues: {
      handler(newVal) {
        if (newVal[this.field.id] !== undefined) {
          this.localData = this.normalizeValue(newVal[this.field.id]);
        }
      },
      deep: true
    }
  },
  methods: {
    // Normaliza el valor entrante para que coincida con el tipo de los option.value
    // (en el render los value llegan como string "1"/"2"; si formValues trae number,
    //  v-model no marcaría el radio por la comparación estricta).
    normalizeValue(value) {
      if (value === undefined || value === null) {
        return "";
      }
      const options = this.field.radio || [];
      // Si los option.value son strings, forzamos string; si son numbers, dejamos number.
      const firstOptionValue = options.length ? options[0].value : null;
      if (typeof firstOptionValue === "string") {
        return String(value);
      }
      if (typeof firstOptionValue === "number") {
        return Number(value);
      }
      return value;
    },
    styleLabel(field, str) {
      return str + (field.styleLabel ?? "");
    },
    updateValue(value) {
      this.$emit('update', { [this.field.id]: value });
    },
    setForm(newVal) {
      this.localData = this.normalizeValue(newVal);
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
    },
    updatePosition(event) {
      this.popupPosition.top = event.clientY + 10; // Añadir un pequeño margen
      this.popupPosition.left = event.clientX + 10; // Añadir un pequeño margen
    },
    keepPopupOpen() {
      if (this.popupTimeout) {
        clearTimeout(this.popupTimeout);
        this.popupTimeout = null;
      }
    },
    delayedClosePopup() {
      this.popupTimeout = setTimeout(() => {
        this.showPopup = false;
      }, 200); // Retraso de 200ms para permitir que el usuario mueva el mouse sobre el popup
    }
  },
  mounted() {
    if (this.formValues[this.field.id] !== undefined) {
      this.localData = this.normalizeValue(this.formValues[this.field.id]);
    }
    this.$eventBus.on("setValue_" + this.field.id.replace(/@/g,"_"), this.setForm);
  },
  unmounted() {
    this.$eventBus.off("setValue_" + this.field.id.replace(/@/g,"_"), this.setForm);
  }
};
</script>

<style scoped>
.caja {
  display: flex;
  align-items: center;
  width: 100%;
}

.radio-option {
  margin-right: 25px;
  display: flex;
  align-items: center;
}

.invalid-feedback {
  display: block;
}

.form-floating {
  position: relative;
}

.form-floating > label {
  position: absolute;
  top: -0.5rem;
  left: 1rem;
  font-size: 0.75rem;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
}

.form-floating > div:focus-within > label {
  top: -1.5rem;
  left: 1rem;
  font-size: 0.75rem;
  color: #007bff;
}

.form-check-label {
  padding-left: 5px;
}

.form-floating > div {
  padding-top: 1.5rem;
}

.info-icon {
  cursor: pointer;
  margin-left: 10px;
  color: #007bff;
}

.info-popup {
  position: absolute;
  z-index: 1000;
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

/* === FIX RADIO BUTTONS (WordPress admin forms.css) ===
   wp-admin aplica appearance:none a input[type=radio] y dibuja el punto
   con un pseudo-elemento, dejando el radio "read only" visual: el estado
   cambia (v-model actualiza localData) pero el control no se repinta.
   Restauramos el render nativo del navegador. */
.owl360-form-check-input[type="radio"] {
  -webkit-appearance: radio;
  appearance: radio;
  margin: 0;
  width: 16px;
  height: 16px;
  border: initial;
  background: initial;
  background-color: initial;
  padding: initial;
  box-shadow: none;
  min-width: initial;
}

.owl360-form-check-input[type="radio"]:checked {
  background: initial;
  background-color: initial;
  border-color: initial;
}

.owl360-form-check-input[type="radio"]::before,
.owl360-form-check-input[type="radio"]::after {
  content: none;
  display: none;
}
</style>